export const CONCERTS_STYLES = {
  DEFAULT: "default",
  WISE: "alternate"
};

export const WISE_LOGO_PATH = "/wise/logo.png";
export const WISE_LED_BG_PATH = "/wise/led_bg.webp";

export const DEFAULT_LOGOS = {
  light: "/logo/jbc-logo-light.webp",
  dark: "/logo/jbc-logo-dark.webp"
};

export const CONCERTS_STYLE_OPTIONS = [
  { label: "Jukebox (default)", value: CONCERTS_STYLES.DEFAULT },
  { label: "Wise", value: CONCERTS_STYLES.WISE }
];

export function normalizeConcertsStyle(value) {
  return value === CONCERTS_STYLES.WISE ? CONCERTS_STYLES.WISE : CONCERTS_STYLES.DEFAULT;
}

/** Event page logo — Wise uses a single asset for both themes. */
export function getEventLogoSrc(concertsStyle, isDark) {
  if (normalizeConcertsStyle(concertsStyle) === CONCERTS_STYLES.WISE) {
    return WISE_LOGO_PATH;
  }
  return isDark ? DEFAULT_LOGOS.dark : DEFAULT_LOGOS.light;
}
